<template>
	<div style=" overflow-y: auto;">
		<div style="min-width: 1122px;">
			<div style='height:10px'></div>
			<Row>
				<Form ref="formInline" :model="formItem" inline :label-width="10" label-position="left">
					<div style="display:inline;">
						<FormItem label v-if="checkFilterItemShow('vElevatorCode')">
							<Input :disabled="checkFilterItemDisable('vElevatorCode')" v-model="formItem.vElevatorCode"
								clearable placeholder="麦信编号" @keydown.native.enter.prevent="search()"
								style="width:140px" />
						</FormItem>
						<!-- <FormItem label v-if="checkFilterItemShow('masterVersion')">
                            <Input :disabled="checkFilterItemDisable('masterVersion')" v-model="formItem.masterVersion" clearable placeholder="当前版本号" @keydown.native.enter.prevent="search()" style="width:140px" />
                        </FormItem> -->
						<FormItem label v-if="checkFilterItemShow('iElevatorType')">
							<Select :disabled="checkFilterItemDisable('iElevatorType')" v-model="formItem.iElevatorType"
								clearable placeholder="电梯类型" style="width:140px">
								<Option :value="item.value" v-for="(item, index) in elevatorTypeSelectList"
									:key="index">{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('eType')">
							<Select :disabled="checkFilterItemDisable('eType')" v-model="formItem.eType" clearable
								placeholder="终端类型" style="width:140px">
								<Option :value="item.value" v-for="(item, index) in deviceTypeSelectList" :key="index">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label
							v-if="checkBtnPermission('device_elevator_sreach') && checkFilterItemShow('vHwVersion') ">
							<Select :disabled="checkFilterItemDisable('vHwVersion')" v-model="formItem.vHwVersion"
								clearable placeholder="设备版本" style="width:140px">
								<Option :value="item.value" v-for="(item, index) in elevatorVHwVersionSelectList"
									:key="index">{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('installStatusArray')">
							<Select multiple="multiple" :disabled="checkFilterItemDisable('installStatusArray')"
								v-model="formItem.installStatusArray" clearable placeholder="安装状态" style="width:140px">
								<Option :value="item.value" v-for="(item, index) in elevatorInstallSelectList"
									:key="index">{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('iOnLine')">
							<Select :disabled="checkFilterItemDisable('iOnLine')||formItem.iFaultStatus==1"
								v-model="formItem.iOnLine" clearable placeholder="在线状态" style="width:140px">
								<Option :value="item.value" v-for="(item, index) in elevatorOnLineSelectList"
									:key="index">{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('vProjectId')">
							<Select :disabled="checkFilterItemDisable('vProjectId')" v-model="formItem.vProjectId"
								filterable placeholder="所属项目" clearable style="width:140px">
								<Option :value="item.v_project_id"
									v-for="(item, index) in elevatorFormItemProjectSelectList" :key="index">
									{{ item.v_project_name }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('vProjectId') && checkFilterItemShow('vVillageId')">
							<Icon type="md-arrow-forward" size="20" />
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('vVillageId')">
							<Select :disabled="checkFilterItemDisable('vVillageId')" v-model="formItem.vVillageId"
								filterable placeholder="所在小区" clearable style="width:140px">
								<Option v-for="(item, index) in villageFormItemSelectList" :key="index"
									:value="item.v_village_id">
									{{ item.v_village_name }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label v-if="checkFilterItemShow('iFaultStatus')">
							<Select :disabled="checkFilterItemDisable('iFaultStatus')" v-model="formItem.iFaultStatus"
								placeholder="故障状态" clearable style="width:140px">
								<Option :value="item.value" v-for="(item, index) in iFaultStatusSelectList"
									:key="index">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>

						<FormItem label v-if="checkFilterItemShow('iModeStatus')">
							<Select :disabled="checkFilterItemDisable('iModeStatus')" v-model="formItem.iModeStatus"
								placeholder="服务模式" clearable style="width:140px">
								<Option :value="item.value" v-for="(item, index) in iModeStatusSelectList" :key="index">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem prop="iProvinceId" v-if="checkFilterItemShow('iProvinceId')">
							<Select :disabled="checkFilterItemDisable('iProvinceId')" v-model="formItem.iProvinceId"
								clearable style="width:140px" placeholder="省">
								<Option v-for="(item, index) in FormProvinceSelectList" :key="index"
									:value="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem prop="iCityId" v-if="checkFilterItemShow('iCityId')">
							<Select :disabled="checkFilterItemDisable('iCityId')" v-model="formItem.iCityId" clearable
								style="width:140px" placeholder="市">
								<Option v-for="(item, index) in FormCitySelectList" :key="index" :value="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem prop="iAreaId" v-if="checkFilterItemShow('iAreaId')">
							<Select :disabled="checkFilterItemDisable('iAreaId')" v-model="formItem.iAreaId" clearable
								style="width:140px" placeholder="区">
								<Option v-for="(item, index) in FormAreaSelectList" :key="index" :value="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</FormItem>
						<FormItem prop="vHttpPtCode" v-if="vHttpPtCode && checkFilterItemShow('vHttpPtCode')">
							<Select :disabled="checkFilterItemDisable('vHttpPtCode')"
								v-if="checkBtnPermission('prop_movement')" v-model="formItem.vHttpPtCode" clearable
								style="width:140px" placeholder="推送平台">
								<Option :value="item.value" v-for="(item, index) in elevatorHttpSendSelectList"
									:key="index">{{ item.label }}</Option>
							</Select>
						</FormItem>
						<!--页面自定义filter放插槽 顺序在尾部-->
						<slot name="filter"></slot>
						<Button type="primary" :loading="searchLoading" shape="circle" icon="ios-search"
							@click="search()">搜索</Button>
						<Button v-if="show && checkBtnPermission('add_elevator')" type="primary" shape="circle"
							icon="md-add" @click="addElevator()">添加电梯</Button>
						<Button v-if="show && checkBtnPermission('import_elevator')" type="primary" shape="circle"
							icon="md-redo" @click="leadingExcel()">导入电梯</Button>
						<Button v-if="show" type="primary" shape="circle" icon="md-redo" @click="DownloadExcel()"
							:loading="searchDownloadLoading">导出excel</Button>
						<Button v-if="showBatchShield" type="primary" shape="circle" icon="md-funnel"
							@click="onBatchShield()">批量拦截</Button>
						<Button v-if="showBatchSensorConfig" type="primary" shape="circle" icon="md-funnel"
							@click="onBatchSensorConfig()">批量配置</Button>
						<slot name="operate"></slot>
					</div>
				</Form>
			</Row>
			<tblcomponents ref="tblcomponents" :tabelConfigVal="tabelConfigVal" :tabelDataVal="tabelData"
				:totalRecordCntVal="totalRecordCnt" :formItem="formItem" data-index="v_elevator_id"
				:tabelLoadingVal="tabelLoading" @search="search" :autoCalcWidth="autoCalcWidth"
				@parentSelect="onParentSelect" @UpdateparentSelect="onUpdateparentSelect" />
			<div style="margin-bottom:10px"></div>
		</div>
	</div>
</template>
<script>
	import {
		getElevatorInfo,
		editElevatorInfo,
		addElevatorInfo,
		getElevatorImg,
		deleteElevatorImg,
		searchElevatorDownload,
		deleteElevatorId,
		getElevatorHeatMapStatistics,
	} from "@/api/elevator/elevatorApi.js";
	import {
		searchElevatorByUserId
	} from "@/api/elevator/elevatorApi.js";
	import {
		searchElevatorProjectSelectList
	} from "@/api/elevatorProject/elevatorProjectApi.js";
	import {
		getPlatformSelectList
	} from "@/api/externalpush/externalpushApi.js";
	import {
		searchVillageSelectList
	} from "@/api/village/villageApi.js";

	import {
		getAreaInfo,
		getAreaInfoNext
	} from "@/api/global/globalApi.js";
	import online from "@/assets/elevator/online.png";
	import offline from "@/assets/elevator/offline.png";

	export default {
		name: "elevatorComponents",
		data() {
			return {
				searchDownloadLoading: false,
				searchLoading: false,
				tabelLoading: false,
				totalRecordCnt: 0,
				elevatorTypeSelectList: [],
				deviceTypeSelectList: [{
						label: 'MX201',
						value: 'MX201'
					},
					{
						label: 'MX204',
						value: 'MX204'
					},
					{
						label: 'MX301',
						value: 'MX301'
					},
					{
						label: 'Camera',
						value: 'Camera'
					}
				],
				elevatorOnLineSelectList: [],
				iModeStatusSelectList: [],
				elevatorInstallSelectList: [],
				villageFormItemSelectList: [],
				elevatorHttpSendSelectList: [],

				FormAreaSelectList: [],
				FormCitySelectList: [],
				FormProvinceSelectList: [],
				iFaultStatusSelectList: [],
				elevatorVHwVersionSelectList: [],
				elevatorFormItemProjectSelectList: [],
				tabelData: [],
				formItem: {
					eType: null,
					vUserId: '',
					vElevatorCode: '',
					dtInstallTime: '',
					iElevatorType: '',
					iInstallStatus: '',
					iOnlineStatusName: '',
					vProjectId: '',
					vVillageId: '',
					iFaultStatus: null,
					iModeStatus: null,
					iProvinceId: '',
					iCityId: '',
					iAreaId: '',
					vHwVersion: '',
					masterVersion: '',
					iOnLine: 1,
				},
				tabelConfigVal: this.defaultTableConfigVal(),
			};
		},
		created() {
			if (this.iOnLineState || this.iOnLineState == 0) {
				this.formItem.iOnLine = this.iOnLineState;
			}
			if (this.iModeStatus) {
				this.formItem.iModeStatus = this.iModeStatus - 0;
			}
			if (this.$route.query.elevatorCode) {
				this.formItem.vElevatorCode = this.$route.query.elevatorCode;
			}
			if (this.$route.query.iInstallStatus) {
				this.formItem.iInstallStatus = this.$route.query.iInstallStatus - 0
			}
			if (this.$route.query.iFaultStatus) {
				this.formItem.iFaultStatus = this.$route.query.iFaultStatus - 0
			}
			if (this.$route.query.iModeStatus) {
				this.formItem.iModeStatus = this.$route.query.iModeStatus - 0
			}
			if (this.$route.query.iOnLine) {
				this.formItem.iOnLine = this.$route.query.iOnLine - 0
			}
			if (this.$route.query.jumpType) {
				if (this.$route.query.jumpType == 1) {
					this.formItem.installStatusArray = [1, 3]
					this.formItem.iInstallStatus = null
					this.formItem.iOnLine = ''
				} else if (this.$route.query.jumpType == 2) {
					this.formItem.installStatusArray = [1, 3]
					this.formItem.iInstallStatus = null

				} else if (this.$route.query.jumpType == 3) {
					this.formItem.installStatusArray = [1, 3]
					this.formItem.iInstallStatus = null
					this.formItem.iOnLine = 0
				} else if (this.$route.query.jumpType == 4) {
					this.formItem.installStatusArray = [1, 3]
					this.formItem.iInstallStatus = null
					this.formItem.iModeStatus = 1
				} else if (this.$route.query.jumpType == 5) {
					this.formItem.installStatusArray = [1, 3]
					this.formItem.iInstallStatus = null
					this.formItem.iFaultStatus = 1
				}

			}
			if (this.vProjectId)
				this.formItem.vProjectId = this.vProjectId

			if (this.vVillageId)
				this.formItem.vVillageId = this.vVillageId

			getPlatformSelectList({
				mainId: "10022"
			}).then((res) => {
				this.elevatorHttpSendSelectList = res.data;
			});
			// 获取版本号
			getAreaInfo().then((res) => {
				this.FormProvinceSelectList = res.data;
			});
			getPlatformSelectList({
				mainId: "10028"
			}).then((res) => {
				this.elevatorVHwVersionSelectList = res.data;
			});
			this.$getSystemSelection("10002").then((res) => {
				this.elevatorTypeSelectList = res.data;
			});
			this.$getSystemSelection("10008").then((res) => {
				this.elevatorInstallSelectList = res.data;
			});
			this.$getSystemSelection("10007").then((res) => {
				this.elevatorOnLineSelectList = res.data;
			});
			this.$getSystemSelection("10009").then((res) => {
				this.iModeStatusSelectList = res.data;
			});
			this.$getSystemSelection("10018").then((res) => {
				this.iFaultStatusSelectList = res.data;
			});
		},
		mounted() {
			// 加载所属项目列表
			searchElevatorProjectSelectList().then((res) => {
				this.elevatorFormItemProjectSelectList = res.data.info.sort((a, b) =>
					a.v_project_name.localeCompare(b.v_project_name, "zh-Hans-CN")
				);
			});
			if (this.autoReq)
				this.search();
		},
		methods: {

			search(params) {

				Object.assign(this.formItem, params)
				this.search()
			},

			search() {

				if (this.formItem.iInstallStatus == 0 || this.formItem.iInstallStatus == 1) {
					// this.formItem.installStatusArray = []
				}
				this.tabelLoading = true;
				this.searchLoading = true;
				this.formItem.vUserId = this.currentUserId;
				if (!this.formItem.eType || this.formItem.eType.length == 0)
					delete this.formItem.eType

				if (this.searchFunc) {
					this.searchFunc(this.formItem).then((res) => {
						this.parseResponse(res)
						this.tabelLoading = false;
						this.searchLoading = false;
					}).catch((err) => {
						this.tabelLoading = false;
						this.searchLoading = false;
					})
				} else {
					searchElevatorByUserId(this.formItem)
						.then((res) => {
							this.parseResponse(res)
							this.tabelLoading = false;
							this.searchLoading = false;
						})
						.catch((err) => {
							this.tabelLoading = false;
							this.searchLoading = false;
						});
				}

			},
			parseResponse(res) {
				if (res.data.code === "0000") {
					const temp = res.data.info.list;
					temp.forEach((item) => {
						if (!item.e_type) item.e_type = 'MX201'
					})

					this.tabelData = temp;
					this.totalRecordCnt = res.data.info.totalRecordCnt;
					this.$refs["tblcomponents"].pageIndex = res.data.info.pageIndex;
					this.$refs["tblcomponents"].pageSize = res.data.info.pageSize;

					// 默认第一行 查看第一行
					if (this.$route.query.elevatorId) {
						// 开启电梯抽屉
						this.modaElevatorFlag = true;
						this.elevatorOperationModulFlag = "detail"; // 查看模式
						this.elevatorId = this.tabelData[0].v_elevator_id;
						this.elevatorCode = this.$route.query.elevatorId;
						this.$route.query.elevatorId = "";
					}
					if (temp[0]) {
						this.elevatorId = temp[0].v_elevator_id;
					}
				}
			},
			addElevator() {
				// this.$parent.fatherMethod();
				this.$emit("addElevator");
			},
			DownloadExcel() {
				// this.$emit('DownloadExcel')
				this.searchDownloadLoading = true;
				searchElevatorDownload(this.formItem).then((res) => {
					const blob = res.data;
					const reader = new FileReader();
					reader.readAsDataURL(blob);
					reader.onload = (e) => {
						const a = document.createElement("a");
						a.download = `Shmashine-Elevator.xls`;
						a.href = e.target.result;
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						this.searchDownloadLoading = false;
					};
				});
			},
			leadingExcel() {
				this.$emit("leadingExcel");
			},

			onBatchShield() {
				this.$emit("batchShield");
			},
			onBatchSensorConfig() {
				this.$emit("batchSensorConfig");
			},
			getTableConfig(selection) {
				let array = this.defaultTableConfigVal()
				array = array.filter((item) => {
					return item.type != 'selection'
				})
				if (selection) {
					array = [{
						type: 'selection'
					}].concat(array)
				}
				return array
			},

			checkFilterItemShow(key) {
				if (!this.filterConfig) return true
				if (this.filterConfig.enableConfig == undefined) return true
				else {
					if (this.filterConfig[key] == undefined) return false
					if (this.filterConfig[key].show == undefined) return false
					return this.filterConfig[key].show
				}
			},

			checkFilterItemDisable(key) {
				if (!this.filterConfig) return false
				if (this.filterConfig.enableConfig == undefined) return false
				else {
					if (this.filterConfig[key] == undefined) return false
					if (this.filterConfig[key].disable == undefined) return false
					return this.filterConfig[key].disable
				}
			},

			defaultTableConfigVal() {
				let customTableConf = {}
				this.$emit('getCustomTableConfig', customTableConf)
				console.log('customTableConf', customTableConf)
				if (customTableConf.data && customTableConf.data.length) {
					return customTableConf.data
				} else {
					return [{
							title: "麦信编号",
							key: "v_elevator_code",
						},
						{
							title: "所属项目",
							key: "v_project_name",
						}, {
							title: "所属小区",
							key: "villageName",
						}, {
							title: "电梯品牌",
							key: "brandName",
						}, {
							title: "电梯类型",
							key: "i_elevator_type_name",
						}, {
							title: "地址",
							key: "v_address",
						}, {
							title: "轿门类型",
							key: "doorType",
							render: (h, params) => {
								if (params.row.doorType === 1) {
									return h("div", [h("font", {}, "贯通门")]);
								} else {
									return h("div", [h("font", {}, "单门")]);
								}
							},
						}, {
							title: "终端类型",
							key: "e_type"
						}, {
							title: "安装状态",
							key: "i_install_status_name",
							render: (h, params) => {
								if (params.row.i_install_status === 0) {
									return h("div", [
										h(
											"font", {
												style: {
													color: "#c5c8ce",
												},
											},
											params.row.i_install_status_name
										),
									]);
								} else {
									return h("div", [
										h(
											"font", {
												style: {
													color: "#2db7f5",
												},
											},
											params.row.i_install_status_name
										),
									]);
								}
							},
						}, {
							title: "故障状态",
							key: "i_fault_status_name",
							render: (h, params) => {
								const deviceList = params.row.deviceList;

								if (!deviceList) {
									return h("div", {}, "--");
								}

								const result = [];
								for (let i = 0; i < deviceList.length; i++) {
									result.push(deviceList[i].onlineStatus);
								}
								if (result.indexOf(0) == -1) {
									if (params.row.i_fault_status === 0) {
										return h("div", [
											h(
												"font", {
													style: {
														color: "#19be6b",
													},
												},
												params.row.i_fault_status_name
											),
										]);
									} else {
										return h("div", [
											h(
												"font", {
													style: {
														color: "#F6416C",
													},
												},
												params.row.i_fault_status_name
											),
										]);
									}
								} else {
									return h("div", {}, "设备离线中");
								}
							},
						}, {
							title: "服务模式",
							key: "i_mode_status_name",
							render: (h, params) => {
								const deviceList = params.row.deviceList;

								if (!deviceList) {
									return h("div", {}, "--");
								}
								const result = [];
								for (let i = 0; i < deviceList.length; i++) {
									result.push(deviceList[i].onlineStatus);
								}
								if (result.indexOf(0) == -1) {
									return h("div", {}, params.row.i_mode_status_name);
								} else {
									return h("div", {}, "设备离线中");
								}
							},
						}, 
						{
							title: "物联网卡",
							key: "i_iot_card_status_name",
							render: (h, params) => {
								const iotFlowEnable = params.row.iotFlowEnable;
								if (iotFlowEnable === 0) {
									return h("div", {}, "限流状态");
								} else {
									return h("div", {}, "启用状态");
								}
							},
						}, 
						
						
						{
							title: "设备状态",
							render: (h, params) => {
								const deviceList = params.row.deviceList;
								if (!deviceList) {
									return h("div", {}, "--");
								}
								const result = [];
								for (let i = 0; i < deviceList.length; i++) {
									if (deviceList[i].onlineStatus === 0) {
										result.push(
											h("img", {
												attrs: {
													style: "margin-right:5px",
													src: offline,
													title: deviceList[i].sensorType +
														"\n最近在线时间: " +
														(deviceList[i].onlineTime == null ?
															"--" :
															deviceList[i].onlineTime) +
														"\n最近离线时间: " +
														(deviceList[i].offlineTime == null ?
															"--" :
															deviceList[i].offlineTime),
												},
											})
										);
									} else {
										result.push(
											h("img", {
												style: "margin-right:5px",
												attrs: {
													src: online,
													title: deviceList[i].sensorType +
														"\n最近在线时间: " +
														deviceList[i].onlineTime +
														"\n最近离线时间: " +
														deviceList[i].offlineTime,
												},
											})
										);
									}
								}
								return result;
							},
						},
						// {
						//     title: "当前版本号",
						//     key: "masterVersion",
						//     width: 340,
						//     render: (h, params) => {
						//         const deviceList = params.row.deviceList;

						//         if (!deviceList) {
						//             return h("div", {}, "--");
						//         }
						//         if (deviceList.length > 0) {
						//             return h("div", {}, params.row.deviceList[0].masterVersion);
						//         }

						//     },
						// },
						{
							title: "操作",
							key: "action",
							width: 340,
							align: "center",
							render: (h, params) => {
								const temp = [];
								Object.keys(this.actions).forEach((item) => {
									temp.push(
										h(
											"Button", {
												props: {
													type: "primary",
													size: "small"
												},
												style: {
													marginRight: "5px"
												},
												on: {
													click: (e) => {
														console.log("params =>", params)
														this.$emit("btnAction", e.target.innerText,
															params);
													},
												},
											},
											item
										)
									);
								});
								return h("div", temp);
							},
						}
					]
				}

			},

			onParentSelect(str) {
				this.$emit('parentSelect', str)
			},

			onUpdateparentSelect(section) {
				this.$emit('updateparentSelect', section)
			},

		},
		watch: {
			// 监听省市区 ======= 编辑页面
			"EditAndInsert.iProvinceId": function(newObj, OldObj) {
				if (newObj) {
					getAreaInfoNext({
						areaId: newObj,
					}).then((res) => {
						this.CitySelectList = res.data;
					});
				}
			},
			"EditAndInsert.iCityId": function(newObj, OldObj) {
				if (newObj) {
					getAreaInfoNext({
						areaId: newObj,
					}).then((res) => {
						this.AreaSelectList = res.data;
					});
				}
			},
			"formItem.iFaultStatus": function(newObj, OldObj) {
				if (newObj) {
					if (newObj == 1) {
						this.formItem.iOnLine = 1
					}
				}
			},
			// 监听项目列表 加载小区
			"EditAndInsert.vProjectId": function(newObj, OldObj) {
				if (newObj) {
					// 获取所属小区
					searchVillageSelectList({
						projectId: newObj
					}).then((res) => {
						this.villageSelectList = res.data.info;
					});
				} else {
					this.villageSelectList = [];
				}
			},
			// 监听省市区 === 查询页面
			"formItem.iProvinceId": function(newObj, OldObj) {
				if (newObj) {
					getAreaInfoNext({
						areaId: newObj,
					}).then((res) => {
						this.FormCitySelectList = res.data;
					});
				}
			},
			"formItem.iCityId": function(newObj, OldObj) {
				if (newObj) {
					getAreaInfoNext({
						areaId: newObj,
					}).then((res) => {
						this.FormAreaSelectList = res.data;
					});
				}
			},

			// 监听项目列表 加载小区 ==== 查询页面
			"formItem.vProjectId": function(newObj, OldObj) {
				if (newObj) {
					console.log(newObj);
					console.log(123);

					// 获取所属小区
					searchVillageSelectList({
						projectId: newObj
					}).then((res) => {
						this.villageFormItemSelectList = res.data.info;
						this.formItem.vVillageId = this.vVillageId
					});
				} else {
					this.villageFormItemSelectList = [];
				}
			},

			'selection'(val) {
				this.tabelConfigVal = this.getTableConfig(val)
				this.$nextTick(() => {
					this.$refs.tblcomponents.updateTableConfig()
				})

			},
		},
		props: {
			showSearch: {
				type: Boolean,
				default: true
			},
			vVillageId: {
				type: String,
			},
			vProjectId: {
				type: String,
			},
			actions: {
				type: Object,
				default: true,
			},
			show: {
				type: Boolean,
			},
			vHttpPtCode: {
				type: Boolean,
			},
			iOnLineState: {
				type: String,
			},
			iModeStatus: {
				type: Number,
			},
			selection: {
				type: Boolean,
				default: false,
			},
			showBatchShield: {
				type: Boolean,
				default: false,
			},
			showBatchSensorConfig: {
				type: Boolean,
				default: false,
			},
			autoReq: {
				type: Boolean,
				default: true
			},
			autoCalcWidth: {
				// 自动计算宽度
				type: Boolean,
				default: true,
			},
			searchFunc: {
				type: Function,
			},
			filterConfig: {
				type: Object
			}
		},
		activated() {
			if (this.$route.query && Object.keys(this.$route.query).length !== 0) {
				Object.keys(this.formItem).forEach((item) => {
					this.formItem[item] = "";
				});
				this.formItem.iInstallStatus = 1
			}
			if (this.$route.query.iOnLine || this.$route.query.iOnLine == 0) {
				this.formItem.iOnLine = this.$route.query.iOnLine - 0;
			}

			if (this.$route.query.iInstallStatus) {
				this.formItem.iInstallStatus = this.$route.query.iInstallStatus - 0;
			}
			if (this.$route.query.iModeStatus) {

				this.formItem.iModeStatus = this.$route.query.iModeStatus - 0;
			}
			if (this.$route.query.elevatorCode) {
				this.formItem.vElevatorCode = this.$route.query.elevatorCode;
			}
			if (this.autoReq)
				this.search();
		}
	}
</script>
<style scoped>
	Button {
		margin-bottom: 24px;
	}
</style>
